import { render, staticRenderFns } from "./OnlineSessionCreate.vue?vue&type=template&id=1c4c4ab2&"
import script from "./OnlineSessionCreate.vue?vue&type=script&lang=js&"
export * from "./OnlineSessionCreate.vue?vue&type=script&lang=js&"
import style0 from "./OnlineSessionCreate.vue?vue&type=style&index=0&id=1c4c4ab2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports